/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Defects_Col_ProductInputs */

const vi_warehouse_defects_col_product = /** @type {(inputs: Warehouse_Defects_Col_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sản phẩm`)
};

/**

* @param {Warehouse_Defects_Col_ProductInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_defects_col_product = /** @type {((inputs?: Warehouse_Defects_Col_ProductInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Defects_Col_ProductInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_defects_col_product(inputs)
});